import { Tabs } from "flowbite-react"
import { PaymentsTable } from "../settings-blocks/PaymentsTable.block"
import { FaAddressCard, FaCircleUser } from "react-icons/fa6";
import { MdPayments } from "react-icons/md";
import { IoDocumentAttach } from "react-icons/io5";
import { CgNotes } from "react-icons/cg";
import { FaHome } from "react-icons/fa";
import { renterTheme } from "./TabsStyle"
import { ImageSelfBlock } from "../settings-blocks/ImageSelf.block";
import RenterInfo from "./RenterInfo"
import ReferenceAndAddressInfo from "./ReferenceAndAddressInfo"
import DocumentsInfo from "./DocumentsInfo"
import { NotesInfo } from "./NotesInfo";


export function RenterDashboard() {
  return (
    <div className="relative flex justify-center w-full h-full overflow-y-auto bg-white dark:bg-white dark:text-black">
      <section className="max-w-7xl w-full p-2">
        <Tabs
          className="tabs-style"
          theme={renterTheme}
          aria-label="Default tabs"
        >
          <Tabs.Item
            icon={FaCircleUser}
            title={
              <div className="tabs-name-style">
                Planos
              </div>
            }
          >
            <ImageSelfBlock />
          </Tabs.Item>

          <Tabs.Item
            icon={MdPayments}
            title={
              <div className="tabs-name-style">
                Pagamentos
              </div>
            }
          >
            <PaymentsTable />
          </Tabs.Item>

          <Tabs.Item
            icon={FaAddressCard}
            title={
              <div className="tabs-name-style">
                Informações
              </div>
            }
          >
            <RenterInfo />
          </Tabs.Item>

          <Tabs.Item
            icon={FaHome}
            title={
              <div className="tabs-name-style">
                Endereço
              </div>
            }
          >
            <ReferenceAndAddressInfo />
          </Tabs.Item>

          <Tabs.Item
            icon={IoDocumentAttach}
            title={
              <div className="tabs-name-style">
                Documentos
              </div>
            }
          >
            <DocumentsInfo />
          </Tabs.Item>

          <Tabs.Item
            icon={CgNotes}
            title={
              <div className="tabs-name-style">
                Observações
              </div>
            }
          >
            <NotesInfo />
          </Tabs.Item>
        </Tabs>
      </section>
    </div>
  )
}